import { render, staticRenderFns } from "./ResetPasswordDone.vue?vue&type=template&id=40903886&"
import script from "./ResetPasswordDone.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordDone.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordDone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports